module.exports = __webpack_public_path__ + "img/Slice5.18e5b87e.png";